export const YieldForecastEndpoint = {
  YIELD_FORECAST_LOAD: '/default/yield-forecast/load',
  YIELD_FORECAST_SAVE: '/default/yield-forecast/yield-forecast-save',
  YIELD_FORECAST2_SAVE: '/default/yield-forecast/yield-forecast2-save',
  ECONOMIC_SAVE: '/default/yield-forecast/economic-save',
  IRRADIATION_SAVE: '/default/yield-forecast/irradiation-save',
  IRRADIATION_HORIZONTAL_SAVE: '/default/yield-forecast/irradiation-horizontal-save',
  ADDITIONAL_VIEW_SAVE: '/default/yield-forecast/additional-view-save',
};
